export default{
    data(){
        return {
            pagination:{
                total:0,
                current:1,
                // pageSize:10,
            },
            searchTerm:{
                // order:'desc',
                // sort:'id'
            }
        }
    },
    methods:{
        handleTableChange(pagination, filters, sorter) {
            if (this.selectedRows) {
                this.selectedRows = []
            }
            this.searchTerm.order = sorter.order != "descend" ? "asc" : "desc";
            sorter.columnKey && (this.searchTerm.sort = sorter.columnKey)
            this.pagination.current = pagination.current;
            this.getdata && this.getdata();
        },
        
    }
}